const awsmobile = {
  /*テスト用(mytodo2b8e3cf4_userpool_2b8e3cf4-dev )*/
  /*
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_qTaXaNbS8",
    "aws_user_pools_web_client_id": "1rihpnm1iq522virur6u8hub60",
    */
  /*
  本番用（Amazon SES）
   "aws_project_region": "ap-northeast-1",
   "aws_cognito_region": "ap-northeast-1",
   "aws_user_pools_id": "ap-northeast-1_oGFsju8TI",
   "aws_user_pools_web_client_id": "21651o3mjceoncq901os1cp0ed",
   */

  /*testkiyota_20230625*/
/*
  "aws_project_region": "ap-northeast-1",
  "aws_cognito_region": "ap-northeast-1",
  "aws_user_pools_id": "ap-northeast-1_FZe9rH3zE",
  "aws_user_pools_web_client_id": "38f317j5ge4f53c4lhghfdgejb",
  */
  /*20230703mapplehomukyokuchizu*/
  
  "aws_project_region": process.env.REACT_APP_AWS_PROJECT_REGION,
  "aws_cognito_region": process.env.REACT_APP_AWS_COGNITO_REGION,
  "aws_user_pools_id": process.env.REACT_APP_AWS_USER_POOLS_ID,
  "aws_user_pools_web_client_id": process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  
};

export default awsmobile;